import { FormOutlined, UserOutlined } from "@ant-design/icons";

// Helper function to check if superadmin cookie exists
const isSuperAdmin = (): boolean => {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith("superadmin="));
};

export const useAdminMenu = () => {
  const routes = [
    {
      path: "/admin/surveys",
      icon: <FormOutlined />,
      key: "surveys",
      name: "Surveys",
    },
  ];

  // Only show Users menu for superadmin
  if (isSuperAdmin()) {
    routes.push({
      path: "/admin/users",
      icon: <UserOutlined />,
      key: "users",
      name: "Users",
    });
  }

  const menu = {
    path: "/admin",
    routes,
  };

  return menu;
};
